<template>
  <div class="CarViolationRecordList">
    <!-- 新组件 -->
    <QS-common-table
      class="mt16"
      :loading="loading.search"
      :data="tableData"
      :columns="headColumn"
      :pagination="paginationData"
      @change="paginationEvent"
    >
      <template slot="col-id" slot-scope="scope">
        <div
          :class="{
            'td-canclick': judgePermission(
              'vehicle_violation_record_list_detail'
            ),
          }"
          :style="{
            color: judgePermission('vehicle_violation_record_list_detail')
              ? '#0059DC'
              : '',
              cursor: judgePermission('vehicle_violation_record_list_detail')
                ? 'pointer'
                : '',
          }"
          @click="
            judgePermission('vehicle_violation_record_list_detail') &&
              detail(scope.row)
          "
        >
          {{ scope.row.id }}
        </div>
      </template>
    </QS-common-table>
    <!-- 违章记录详情 -->
    <div class="alertBox3">
      <dialogWrap
        v-model="detailShow"
        :title="detailTitle"
        :width="'824px'"
        :destory-on-close="true"
        :before-close="dialogclose"
      >
        <template>
          <el-form>
            <column-box
              :column="2"
              :source="detailSource"
              :list="detailList"
              :labelWidth="130"
            >
            </column-box>
          </el-form>
        </template>
      </dialogWrap>
    </div>
    <!-- 违章记录处理 -->
    <div class="alertBox2">
      <dialogWrap
        v-model="violationShow"
        :title="violationTitle"
        :width="'824px'"
        :before-close="setBtnCancel"
      >
        <template>
          <el-form
            :inline="true"
            :model="source"
            ref="source_from"
            :rules="source_rules"
            label-width="130px"
            class="violation-form"
          >
            <el-col :span="12">
              <el-form-item :label="'车牌号' + columnSeparator" prop="plateNo">
                <span>{{ source.plateNo }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="'违章时间' + columnSeparator"
                prop="violationTime"
              >
                <span>{{ source.violationTime }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="相关客户" prop="customerId">
                <el-select
                  v-model="source.customerId"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入关键词"
                  :remote-method="customerIdremoteMethod"
                  :loading="loading.fuzzy"
                  clearable
                >
                  <el-option
                    v-for="item in optionsName"
                    :key="item.id"
                    :label="item.customerName"
                    :value="item.id"
                  >
                    <CustomerNameOptionItem :data="item" />
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="'相关订单' + columnSeparator"
                prop="orderId"
              >
                <el-input
                  style="width: 210px"
                  placeholder="请输入"
                  v-number:integer="18"
                  v-model="source.orderId"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="'违章内容' + columnSeparator"
                prop="content"
              >
                <div class="content">{{ source.content }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="'违章地点' + columnSeparator" prop="place">
                <el-input
                  v-model="source.place"
                  v-deleteEmoji="true"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="'违章扣分' + columnSeparator"
                prop="penaltyPoint"
              >
                <span>{{ source.penaltyPoint }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="'处理状态' + columnSeparator"
                prop="handleState"
              >
                <el-select
                  placeholder="请选择"
                  v-model="source.handleState"
                  clearable
                  @change="resolveStatus"
                >
                  <el-option
                    v-for="item in handleStateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="'违章罚款' + columnSeparator"
                prop="penaltyAmount"
              >
                <span>{{ source.penaltyAmount }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="'缴款状态' + columnSeparator"
                prop="paymentState"
              >
                <el-select
                  placeholder="请选择"
                  v-model="source.paymentState"
                  clearable
                >
                  <el-option
                    v-for="item in paymentStateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 处理时间 -->
            <el-col :span="13" v-show="resolveTimeStatus">
              <el-form-item
                :label="'处理时间' + columnSeparator"
                prop="handleCompleteTime"
              >
                <el-date-picker
                  v-model="source.handleCompleteTime"
                  placeholder="选择日期时间处理时间"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="'备注' + columnSeparator"
                label-width="130px"
                prop="handleRemarks"
              >
                <el-input
                  v-deleteEmoji="true"
                  style="width: 210px"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入"
                  v-model="source.handleRemarks"
                  maxlength="500"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="resolveTimeStatus">
              <el-form-item
                :label="'处理方式' + columnSeparator"
                label-width="130px"
                prop="dealViolationWay"
              >
                <el-select
                  placeholder="请选择"
                  v-model="source.dealViolationWay"
                  clearable
                >
                  <el-option
                    v-for="item in dealViolationWayList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form>
          <template slot="footer">
            <el-button @click="setBtnCancel" size="small">取消</el-button>
            <el-button type="primary" :loading="submitLoading" @click="handleBtn" size="small"
              >处理完成</el-button
            >
          </template>
        </template>
      </dialogWrap>
    </div>
    <!-- 删除弹框 -->
    <dialogWrap v-model="centerDialogVisible" title="提示" :width="'560px'">
      <p>是否删除该违章记录</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button :loading="loading.del" type="primary" @click="deleteFun()"
          >删除</el-button
        >
      </span>
    </dialogWrap>
    <!-- 违章处理方式 -->
    <selectViolationWay
      :visible="dvWayVisible"
      :id="violationId"
      @dvWayUpdated="refreshDetail"
      @dvWayChange="dvWayVisible = false"
    />
  </div>
</template>

<script>
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import {
  getViolationInfo,
  getSensitiveViolationInfo,
  getViolationDetail,
  ViolationUpdate,
  ViolationsDelte,
} from '@/api/domain/carsService'
import selectOption from '@/store/dict/selectOptionDict'
import selectViolationWay from '@/pages/carsService/violation/components/selectViolationWay'
import moment from 'moment'
import { operateMaxShowLength } from '@/store/dict/config'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
import WindowCommunication from '@/utils/windowCommunication'

export default {
  components: {
    selectViolationWay,
    CustomerNameOptionItem,
  },
  data() {
    return {
      optionsName: [], // 客户模糊列表
      // 表格数据
      tableData: [],
      detailShow: false, // 违章详情弹框的显隐
      detailTitle: '违章处理详情',
      // 违章记录详情数据
      detailList: [
        {
          key: 'plateNo',
          name: '车牌号',
        },
        {
          key: 'violationTime',
          name: '违章时间',
        },
        {
          key: 'customerName',
          name: '相关客户',
        },
        {
          key: 'orderId',
          name: '相关订单',
        },
        {
          key: 'content',
          name: '违章内容',
        },
        {
          key: 'penaltyPoint',
          name: '违章扣分',
        },
        {
          key: 'handleState',
          name: '处理状态',
        },
        {
          key: 'penaltyAmount',
          name: '违章罚款',
        },
        {
          key: 'paymentState',
          name: '缴款状态',
        },
        {
          key: 'handleRemarks',
          name: '备注',
        },
        {
          key: 'handleCompleteTime',
          name: '处理时间',
        },
        {
          key: 'dealViolationWay',
          name: '处理方式',
        },
        {
          key: 'latestUpdateTime',
          name: '最后更新时间',
        },
        {
          key: 'deptName',
          name: '所属部门',
        },
      ],
      detailSource: {},
      violationShow: false, // 违章处理弹框的显隐
      violationTitle: '违章备注',
      source: {
        handleRemarks: '',
        completeTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      },
      source_rules: {
        plateNo: [
          { required: true, message: '车牌号不能为空', trigger: 'blur' },
        ],
        violationTime: [
          { required: true, message: '违章时间不能为空', trigger: 'blur' },
        ],
        content: [
          { required: true, message: '违章内容不能为空', trigger: 'blur' },
        ],
        penaltyPoint: [
          { required: true, message: '违章扣分不能为空', trigger: 'blur' },
        ],
        handleState: [
          { required: true, message: '处理状态不能为空', trigger: 'blur' },
        ],
        penaltyAmount: [
          { required: true, message: '违章罚款不能为空', trigger: 'blur' },
        ],
        paymentState: [
          { required: true, message: '缴款状态不能为空', trigger: 'blur' },
        ],
      },
      // 删除弹窗
      centerDialogVisible: false,
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      dvWayVisible: false,
      violationId: 0,
      submitLoading: false,
    }
  },
  props: {
    loading: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    // 判断是不是车辆详情
    isCarDetail: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 表格头部
    headColumn() {
      return [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '违章单ID',
            width: 100,
          },
          type: 'manual',
        },
        {
          name: 'orderId',
          columnProps: {
            prop: 'orderId',
            label: '订单ID',
          },
          render: ({ row }) => {
            if (row.orderId) return row.orderId
            return (
              <el-tooltip
                class="item"
                effect="dark"
                content="未关联到租赁订单信息，请检查违章时间是否发生在订单出入库交接时间范围内。"
                placement="top-start"
              >
                <span>--</span>
              </el-tooltip>
            )
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
          },
          showColumnItem: !this.isCarDetail,
        },
        {
          name: 'rentStatusName',
          columnProps: {
            prop: 'rentStatusName',
            label: '租赁状态',
            width: 100,
          },
        },
        {
          name: 'customerName',
          columnProps: {
            prop: 'customerName',
            label: '相关客户',
          },
          render: ({ row }) => {
            if (row.customerName) return row.customerName
            return (
              <el-tooltip
                class="item"
                effect="dark"
                content="未关联到租赁订单信息，请检查违章时间是否发生在订单出入库交接时间范围内。"
                placement="top-start"
              >
                <span>--</span>
              </el-tooltip>
            )
          },
        },
        {
          name: 'orderTypeDesc',
          columnProps: {
            prop: 'orderTypeDesc',
            label: '相关订单类型',
            width: 110,
          },
          render: ({ row }) => {
            if (row.orderTypeDesc) return row.orderTypeDesc
            return (
              <el-tooltip
                class="item"
                effect="dark"
                content="未关联到租赁订单信息，请检查违章时间是否发生在订单出入库交接时间范围内。"
                placement="top-start"
              >
                <span>--</span>
              </el-tooltip>
            )
          },
        },
        {
          name: 'orderId',
          columnProps: {
            prop: 'orderId',
            label: '相关订单',
          },
          render: ({ row }) => {
            if (row.orderId) return row.orderId
            return (
              <el-tooltip
                class="item"
                effect="dark"
                content="未关联到租赁订单信息，请检查违章时间是否发生在订单出入库交接时间范围内。"
                placement="top-start"
              >
                <span>--</span>
              </el-tooltip>
            )
          },
        },
        {
          name: 'violationTime',
          columnProps: {
            prop: 'violationTime',
            label: '违章时间',
            width: 170,
          },
        },
        {
          name: 'place',
          columnProps: {
            prop: 'place',
            label: '违章地点',
          },
        },
        {
          name: 'content',
          columnProps: {
            prop: 'content',
            label: '违章行为',
            width: 160,
          },
        },
        {
          name: 'appearStateName',
          columnProps: {
            prop: 'appearStateName',
            label: '备案状态',
          },
        },
        {
          name: 'penaltyPoint',
          columnProps: {
            prop: 'penaltyPoint',
            label: '违章扣分',
          },
        },
        {
          name: 'handleState',
          columnProps: {
            prop: 'handleState',
            label: '违章处理',
          },
          getText: ({ row }) =>
            selectOption.processingstatusDict[row.handleState],
        },
        {
          name: 'handleCompleteTime',
          columnProps: {
            prop: 'handleCompleteTime',
            label: '处理时间',
            width: 170,
          },
        },
        {
          name: 'penaltyAmount',
          columnProps: {
            prop: 'penaltyAmount',
            label: '违章罚款',
          },
          getText: ({ row }) => this.numberWithCommas(row.penaltyAmount),
        },
        {
          name: 'paymentState',
          columnProps: {
            prop: 'paymentState',
            label: '缴款状态',
          },
          getText: ({ row }) => selectOption.paymentStateList[row.paymentState],
        },
        {
          name: 'dealViolationWay',
          columnProps: {
            prop: 'dealViolationWay',
            label: '处理方式',
          },
          render: ({ row }) => {
            if (row.dealViolationWay) {
              return selectOption.dealViolationWayList[row.dealViolationWay]
            }

            return (
              <el-tooltip
                class="item"
                effect="dark"
                content="违章处理完成后，可进行操作添加。"
                placement="top-start"
              >
                <span>--</span>
              </el-tooltip>
            )
          },
        },
        {
          name: 'handleRemarks',
          columnProps: {
            prop: 'handleRemarks',
            label: '处理备注',
          },
          render: ({ row }) => {
            if (row.handleRemarks) return row.handleRemarks
            return (
              <el-tooltip
                class="item"
                effect="dark"
                content="违章处理完成后，可进行操作添加。"
                placement="top-start"
              >
                <span>--</span>
              </el-tooltip>
            )
          },
        },
        {
          name: 'latestUpdateTime',
          columnProps: {
            width: 160,
            prop: 'latestUpdateTime',
            label: '最后更新时间',
          },
        },
        {
          name: 'deptName',
          columnProps: {
            prop: 'deptName',
            label: '所属部门',
          },
        },
        {
          name: 'operate',
          columnProps: {
            prop: 'operate',
            label: '操作',
            fixed: 'right',
            width: 100,
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ row }) => {
            const result = [
              {
                name: 'edit',
                label: '违章备注',
                action: () => this.violation(row),
              },
            ]
            if (this.judgePermission('vehicle_violation_record_list_delete')) {
              result.push({
                name: 'dele',
                label: '删除',
                action: () => this.openDel(row),
              })
            }
            return result
          },
        },
      ]
    },
    // 处理状态
    handleStateList() {
      return this.dictParseList(selectOption.processingstatusDict)
    },
    // 缴款状态
    paymentStateList() {
      return this.dictParseList(selectOption.paymentStateList)
    },
    // 处理时间是否显示
    resolveTimeStatus() {
      // 处理状态：1-已处理
      if (Number(this.source.handleState) === 1) return true
      return false
    },
    dealViolationWayList() {
      return this.dictParseList(selectOption.dealViolationWayList)
    },
  },
  methods: {
    /* 客户模糊搜索 */
    async customerIdremoteMethod(query) {
      // eslint-disable-next-line vue/no-mutating-props
      this.loading.fuzzy = true
      try {
        const { code, data } = await searchByCustomerNameSensitive({
          customerName: query ? query.trim() : '',
          customerState: 1,
          mixedType: 'YES',
        })
        // 关闭远程搜索
        // eslint-disable-next-line vue/no-mutating-props
        this.loading.fuzzy = false
        if (code === 1) {
          this.optionsName = data || []
        }
      } catch (error) {
        // eslint-disable-next-line vue/no-mutating-props
        this.loading.fuzzy = false
      }
    },
    deleteFun() {
      this.getDel(this.violationId)
    },
    // 删除请求
    async getDel(res) {
      try {
        // eslint-disable-next-line vue/no-mutating-props
        this.loading.del = true
        const data = await ViolationsDelte({
          id: res,
        })
        // eslint-disable-next-line vue/no-mutating-props
        this.loading.del = false
        if (data.code === 1) {
          this.$message.success('删除成功')
          this.centerDialogVisible = false
          this.getDetails(this.params)
          this.sendMessage()
        }
      } catch (error) {
        // eslint-disable-next-line vue/no-mutating-props
        this.loading.del = false
      }
    },
    /* 打开删除 */
    openDel(res) {
      this.centerDialogVisible = true
      this.violationId = res.id
    },
    // 打开违章处理方式
    // eslint-disable-next-line vue/no-unused-properties
    openWay(row) {
      this.violationId = row.id
      this.dvWayVisible = true
    },
    // 违章处理取消按钮
    setBtnCancel() {
      this.source = {
        handleRemarks: '',
        completeTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      }
      this.$refs.source_from.resetFields()
      this.violationShow = false
    },
    /* 违章处理接口 */
    async handleBtn() {
      if (this.submitLoading) return
      this.submitLoading = true
      try {
        await this.$refs.source_from.validate()
        const res = await ViolationUpdate(this.source)
        if (res.code !== 1) {
          this.submitLoading = false
          return
        }
        this.$message.success('处理成功')
        this.violationShow = false
        this.getDetails(this.params)
        this.sendMessage()
      } catch {
        this.submitLoading = false
      }
    },
    /* 违章处理 */
    // eslint-disable-next-line vue/no-unused-properties
    violation(row) {
      this.violationShow = !this.violationShow
      if (this.violationShow) {
        this.submitLoading = false
        // 先获取全量相关用户
        this.customerIdremoteMethod()
      }
      const { id } = row
      getViolationInfo({ id }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.source = { ...this.source, ...data }
        }
      }).finally(() => {
        // eslint-disable-next-line vue/no-mutating-props
        this.loading.fuzzy = false
      })
    },
    dialogclose() {
      this.detailSource = {}
      this.detailShow = false
    },
    /* 违章单Id */
    detail(row) {
      this.detailShow = !this.detailShow
      const { id } = row
      getSensitiveViolationInfo({ id }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          const { handleState, paymentState, dealViolationWay } = data
          this.detailSource = {
            ...data,
            handleState: selectOption.processingstatusDict[handleState],
            paymentState: selectOption.paymentStateList[paymentState],
            dealViolationWay:
              selectOption.dealViolationWayList[dealViolationWay],
          }
        }
      })
    },
    /* 分页切换 */
    paginationEvent(payload) {
      const { pagination } = payload || {}
      if (pagination) {
        this.paginationData = Object.assign(this.paginationData, pagination)
      }
      // eslint-disable-next-line vue/no-mutating-props
      this.params.pageSize = pagination?.pageSize || 10
      // eslint-disable-next-line vue/no-mutating-props
      this.params.pageNum = pagination?.pageNum || 1
      this.getDetails(this.params)
    },
    /* 获取详情 */
    async getDetails(res) {
      // eslint-disable-next-line vue/no-mutating-props
      this.loading.search = true
      try {
        const { code, data } = await getViolationDetail({
          ...res,
          updateViolationFromTime: res.updateViolationTime[0],
          updateViolationToTime: res.updateViolationTime[1],
        })
        // eslint-disable-next-line vue/no-mutating-props
        this.loading.search = false
        if (code === 1) {
          this.tableData = data.items
          this.paginationData.total = data.totalNum
        }
      } catch {
        // eslint-disable-next-line vue/no-mutating-props
        this.loading.search = false
      }
    },
    // 处理状态
    resolveStatus() {
      this.$set(this.source, 'handleCompleteTime', '')
      this.$set(this.source, 'dealViolationWay', '')
    },
    refreshDetail() {
      this.getDetails(this.params)
    },
    sendMessage() {
      // 跨页面通信 通知签约提车车辆状态信息刷新
      if (this.$route.query.scene) {
        const communication = new WindowCommunication('person_sign_contract')
        communication.send({
          type: 'unavailable_message',
          data: true,
        })
        // 关闭window
        window.close()
      }
    },
  },
  mounted() {
    // 父组件mounted中有操作this.params，此处子组件mounted钩子优先于父组件mounted，所以$nextTick后执行
    this.$nextTick(() => {
      this.getDetails(this.params)
    })
    // eslint-disable-next-line vue/no-mutating-props
    this.loading.fuzzy = true
  },
}
</script>
<style scoped lang="scss">
.content {
  width: 610px;
}
.violation-form {
  ::v-deep .el-form-item {
    margin-right: 0;
  }
}
</style>
